module.exports = new __parcel__URL__("frozenreversal.8820037f.png").toString();